import _objectWithoutProperties from "/workdir/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workdir/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/workdir/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workdir/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workdir/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { PureComponent } from 'react';
/** @deprecated Use the useEventListener hook instead. */

var EventListener = /*#__PURE__*/function (_PureComponent) {
  _inherits(EventListener, _PureComponent);

  var _super = _createSuper(EventListener);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _super.apply(this, arguments);
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.attachListener();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref) {
      var passive = _ref.passive,
          detachProps = _objectWithoutProperties(_ref, ["passive"]);

      this.detachListener(detachProps);
      this.attachListener();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.detachListener();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }, {
    key: "attachListener",
    value: function attachListener() {
      var _this$props = this.props,
          event = _this$props.event,
          handler = _this$props.handler,
          capture = _this$props.capture,
          passive = _this$props.passive;
      window.addEventListener(event, handler, {
        capture: capture,
        passive: passive
      });
    }
  }, {
    key: "detachListener",
    value: function detachListener(prevProps) {
      var _ref2 = prevProps || this.props,
          event = _ref2.event,
          handler = _ref2.handler,
          capture = _ref2.capture;

      window.removeEventListener(event, handler, capture);
    }
  }]);

  return EventListener;
}(PureComponent);

export { EventListener };